<script setup>
import { NFlex } from 'naive-ui'; 
import { computed } from 'vue';

import literacyIc01 from '@/assets/images/result/literacy_ic_01.png';
import literacyIc02 from '@/assets/images/result/literacy_ic_02.png';
import literacyIc03 from '@/assets/images/result/literacy_ic_03.png';
import literacyIc04 from '@/assets/images/result/literacy_ic_04.png';

import numeracyIc01 from '@/assets/images/result/numeracy_ic_01.png';
import numeracyIc02 from '@/assets/images/result/numeracy_ic_02.png';
import numeracyIc03 from '@/assets/images/result/numeracy_ic_03.png';
import numeracyIc04 from '@/assets/images/result/numeracy_ic_04.png';

const props = defineProps({
  type: { 
    type: String,
    required: true,
    validator: (value) => ['literacy', 'numeracy'].includes(value)
  },
  region: { 
    type: String, 
    default: '',
  },
  isStudent: {
    type: Boolean,
    default: false
  },
   userRole: { 
    type: String,
    default: 'teacher', // 기본값은 선생님
    validator: (value) => ['student', 'teacher', 'principal'].includes(value),
  },
  subAreaLevels: {
    type: Array,
    default: () => ['', '', '', '']
  }
});

const cardClasses = computed(() => {
  return {
    'char': props.isStudent,     
  };
});

const subAreaItems = computed(() => {
  if (props.type === 'literacy') {
    return [
      { icon: literacyIc01, title: '어휘', description: '단어, 어구, 절의 의미를 정확하게 이해하고 활용하는 능력' },
      { icon: literacyIc02, title: '통합 및 해석', description: '글, 그림 등 자료의 내용을 통합하면서 추론적으로 이해하는 능력' },
      { icon: literacyIc03, title: '탐색 및 확인', description: '글, 그림 등 자료의 내용을 확인하고 탐색하면서 사실적으로 이해하는 능력 ' },
      { icon: literacyIc04, title: '비판 및 평가', description: '글, 그림 등 자료의 내용을 분석하고 검사하면서 비판적으로 평가하고 다른 상황에 적용하는 능력' }
    ];
  } else {
    return [
      { icon: numeracyIc01, title: '수와 양', description: '실세계에서 수량을 파악하고 계산하며<br>표현하는 능력' },
      { icon: numeracyIc02, title: '모양과 측정', description: '모양과 도형의 성질을 탐구하고 공간적으로 사고하며 크기를 측정하는 능력' },
      { icon: numeracyIc03, title: '규칙과 관계', description: '규칙과 관계를 발견하고 수식으로 표현하고 해석하는 능력' },
      { icon: numeracyIc04, title: '자료와<br>불확실성', description: '자료를 수집, 정리, 해석하고 불확실성을<br>다루는 능력' }
    ];
  }
});

const title = computed(() => {
  let areaText = props.type === 'literacy' ? '문해력' : '수리력';
  let centerText = '';
  if (props.userRole === 'student') {    
    centerText += '을 구성하는'; 
  }    
  return `${areaText}${centerText} 하위 영역`;
});
</script>

<template>
  <div class="card sub-area" :class="props.type">
    <h5 class="card-title" :class="[props.type, props.region, cardClasses]">{{ title }}</h5>
    <n-flex wrap="wrap" :size="[16,20]" class="pt-10 pb-5">
      <div class="box" v-for="(item, index) in subAreaItems" :key="index">
        <div class="icon-wrap">
          <img :src="item.icon" :alt="`${item.title}-아이콘`"/>
        </div>
        <p v-html="item.title" class="text-[18px]"></p>
        <p v-html="item.description" class="text-[18px]"></p>
      </div>
    </n-flex>
  </div>
</template>

<style lang="scss" scoped>
.box {
    width: calc(50% - 10px);
    display: flex;
    align-items: center;
    .icon-wrap { 
        max-width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1;
    }
    p:nth-child(2) { 
        flex: 1.25;
        text-align: center;
        font-weight: 600;
        line-height: 1.2;
    }
    p:nth-child(3) {
        flex: 4;
        position: relative;
        padding-left: 15px;
        border-left: 1px solid #ccc;
    }
}
.literacy .box p:nth-child(2) {color: var(--result-blue);}
.numeracy .box p:nth-child(2) {color: var(--result-red);}

.card-title.literacy  {
  &.char.seoul {
    position: relative;
    &::after {
      content: '';
      position: absolute;
      background-image: url("@/assets/images/result/char_01.png");
      width: 144px;
      height: 120px;
      top: 50%;
      right: -30px;
      transform: translateY(-50%);
      background-repeat: no-repeat;
      background-size: contain;
    }
  }
}
.card-title.numeracy  {
  &.char.seoul {
    position: relative;
    &::after {
      content: '';
        position: absolute;
        background-image: url("@/assets/images/result/char_02.png");
        width: 120px;
        height: 120px;
        top: 50%;
        right: -35px;
        transform: translateY(-60%);
        background-repeat: no-repeat;
        background-size: contain;
    }
  }
}
</style>